import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ApiResult } from '../../../../../shared/models/api-result.model';
import { DisplayAreaModel } from '../../../../models/display-area.model';
import { DisplayAreaService } from '../../../../services/display-area.service';

@Component({
  selector: 'app-footer',
  imports: [RouterLink],
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
  private displayAreaService = inject(DisplayAreaService);

  productModels = signal<DisplayAreaModel[]>([]);

  currentYear = new Date().getFullYear();

  ngOnInit(): void {
    this.loadProductModels();
  }

  scrollToElement(elementId: string): void {
    setTimeout(() => {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  }

  private loadProductModels(): void {
    this.displayAreaService.getModelsBySlug('products-page-models').subscribe({
      next: (response: ApiResult) => {
        this.productModels.set(response.data as DisplayAreaModel[]);
      },
      error: (e) => console.error(e),
    });
  }
}
